import { Checkbox } from '@material-ui/core';
import React from 'react';

import { Col, Cols, Row, Rows, spacingV2, Text } from '~/src/dash/publicaUI';
import { IListItem } from '~/src/dash/types/menuList';

interface ICheckboxesProp {
  list: IListItem[];
  onChange: (id: string) => void;
}

export const Checkboxes = ({ list, onChange }: ICheckboxesProp) => {
  return (
    <Rows noHorizontalPaddingV2>
      {Object.values(list).map((item: IListItem) => (
        <Row noPadding>
          <Cols
            onClick={() => {
              if (!item.disabled) onChange(item.ID);
            }}
            style={{
              cursor: item.disabled ? 'default' : 'pointer',
              alignItems: 'flex-start',
              paddingLeft: spacingV2.large,
              paddingBottom: spacingV2.small,
            }}
          >
            <Col>
              <Checkbox
                size='small'
                checked={item.selected}
                disabled={item.disabled}
                style={{
                  width: '10px',
                  marginLeft: '4px',
                  marginRight: '8px',
                  padding: '0',
                }}
              />
            </Col>
            <Col>
              <Text small>{item.title}</Text>
            </Col>
          </Cols>
        </Row>
      ))}
    </Rows>
  );
};
